module.exports = __webpack_public_path__ + "static/sectionafter-e350193e0b734562beadc58d3a74e026.png";